import { ApolloClient, gql, TypedDocumentNode } from '@apollo/client'
import { employeeCertificateFragment } from '../fragments/EmployeeCertificateFragment'
import type {
  UpdateEmployeeCertificateMutation,
  UpdateEmployeeCertificateMutationVariables
} from './__generated__/UpdateEmployeeCertificateMutation'

const mutation: TypedDocumentNode<
  UpdateEmployeeCertificateMutation,
  UpdateEmployeeCertificateMutationVariables
> = gql`
  ${employeeCertificateFragment}

  mutation UpdateEmployeeCertificateMutation(
    $input: UpdateEmployeeCertificateInput!
  ) {
    updateEmployeeCertificate(input: $input) {
      certificate {
        ...EmployeeCertificateFragment
      }
    }
  }
`

export function updateEmployeeCertificateMutation(
  apolloClient: ApolloClient,
  options: Omit<
    ApolloClient.MutateOptions<
      UpdateEmployeeCertificateMutation,
      UpdateEmployeeCertificateMutationVariables
    >,
    'mutation'
  >
) {
  return apolloClient.mutate({
    mutation,
    ...options
  })
}
